let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("60SPd")).then(() => parcelRequire('8Axq6'));